module.exports = __webpack_public_path__ + "static/media/fullscreen.35be770f.svg";